<template>
  <div>
    <div>
      <v-form @submit.prevent ref="form" v-model="valid">
        <v-row class="d-flex align-end">
          <v-col cols="12">
            <slot></slot>
          </v-col>
          <v-col cols="8">
            <v-text-field
              class="ma-0"
              label=""
              v-model.trim="item"
              :rules="titleRules"
              color="green"
              type="text"
              :id="`${title}-title`"
              required
              :hide-details="true"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="d-flex flex-row">
            <v-btn
              :class="color"
              class="green lighten-2 align-self-end"
              @click="addNote"
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </div>
    <draggable class="inner" :list="items" group="notes">
      <div
        class="ma-1"
        :class="color"
        v-for="(tag, index) in items"
        :key="index"
      >
        <span class="pr-2 cursor--order body-1 green--text darken-2">
          {{ tag }}
        </span>
        <v-icon small @click="removeItem(index)">mdi-close</v-icon>
      </div>
    </draggable>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "SubItems",
  props: {
    title: String,
    subtitle: String,
    color: String,
    value: Array,
    fullHeight: Boolean,
  },
  components: {
    draggable,
  },
  data() {
    return {
      items: this.value,
      valid: true,
      item: "",
      titleRules: [(v) => !!v || "Title is required"],
    };
  },
  watch: {
    items: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.items = val;
    },
  },
  methods: {
    addNote() {
      this.validate();
      if (this.valid) {
        this.items.push(this.item);
        this.item = "";
        this.resetValidation();
      }
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    validate() {
      this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
